'use strict';
define([
    'angular',
    'modules/keywordlistmanager/list/list.controller'
], function (angular, KeywordListManagerListCtrl) {
    var app = angular.module('app.keywordlistmanager.list', []);
    app.controller('KeywordListManagerListCtrl', KeywordListManagerListCtrl);
    return app;
});
